import { get } from '..';
import { applySolveAnalyticsFilters, GetSolveAnalyticsStatsProps } from './Utils';

const GetTicketsRaisedCounts = (props: GetSolveAnalyticsStatsProps) => {
  const baseUrl: string = 'solve-analytics/tickets/raised-counts';
  const url: string = applySolveAnalyticsFilters(baseUrl, props);
  return get(url);
};

export default GetTicketsRaisedCounts;
